import { IStores } from "./index";
import * as services from "services";
import { ListStoreConstructor } from "./ListStoreConstructor";
import { BidList as BidListType } from "interfaces";

export class PendingActionsBidList extends ListStoreConstructor<BidListType> {
  constructor(stores: IStores) {
    super(
      stores,
      (params) => {
        return services.getPendingActionsBidList(params).then((response) => ({
          content: response.content || [],
          size: response.size || 0,
          totalPages: response.totalPages || 0,
          totalElements: response.totalElements || 0,
        }));
      },
      {
        pollingInterval: 10000,
        sorters: {
          statusDate: "desc",
        },
      }
    );
  }
}
